// extracted by mini-css-extract-plugin
export default {"banner":"about_banner__fS9Ma","about":"about_about__1gpBz","vision-mission":"about_vision-mission__eLO5a","our-founders":"about_our-founders__tH6Mx"};